// Shared helpers for the PoolDetail tabs.

export function fmtTime(iso, lang) {
    if (!iso) return "—";
    try {
        const locale = lang === "sv" ? "sv-SE" : undefined;
        return new Date(iso).toLocaleString(locale, {
            weekday: "short", month: "short", day: "numeric",
            hour: "2-digit", minute: "2-digit",
        });
    } catch { return iso; }
}

export function isLocked(kickoff) {
    if (!kickoff) return false;
    return new Date(kickoff).getTime() <= Date.now();
}

// Common WC2026 team short codes (FIFA 3-letter codes). Falls back to the
// first 3 letters of the team name upper-cased when not in the map.
const TEAM_SHORT_CODES = {
    "Algeria": "ALG", "Argentina": "ARG", "Australia": "AUS", "Austria": "AUT",
    "Belgium": "BEL", "Bosnia-Herzegovina": "BIH", "Brazil": "BRA", "Canada": "CAN",
    "Cape Verde": "CPV", "Colombia": "COL", "Croatia": "CRO", "Curaçao": "CUW",
    "Czechia": "CZE", "Denmark": "DEN", "Ecuador": "ECU", "Egypt": "EGY",
    "England": "ENG", "France": "FRA", "Germany": "GER", "Ghana": "GHA",
    "Haiti": "HAI", "Iran": "IRN", "Ivory Coast": "CIV", "Côte d'Ivoire": "CIV",
    "Japan": "JPN", "Jordan": "JOR", "Mexico": "MEX", "Morocco": "MAR",
    "Netherlands": "NED", "New Zealand": "NZL", "Norway": "NOR", "Panama": "PAN",
    "Paraguay": "PAR", "Portugal": "POR", "Qatar": "QAT", "Saudi Arabia": "KSA",
    "Scotland": "SCO", "Senegal": "SEN", "South Africa": "RSA", "South Korea": "KOR",
    "Spain": "ESP", "Sweden": "SWE", "Switzerland": "SUI", "Tunisia": "TUN",
    "Turkey": "TUR", "Türkiye": "TUR", "United States": "USA", "USA": "USA", "Uruguay": "URU",
};

export function teamShort(team) {
    if (!team) return "?";
    if (team.code) return team.code.toUpperCase();
    if (TEAM_SHORT_CODES[team.name]) return TEAM_SHORT_CODES[team.name];
    return (team.name || "?").replace(/[^A-Za-z]/g, "").slice(0, 3).toUpperCase();
}
